import { useEffect } from 'react'

import { removeLocationPin } from '@/map'

export function useRemoveLocationPinOnLeaving(pinId: uui.domain.ui.map.LocationPinId) {
  // remove the target locationPin when the component unmounts
  useEffect(() => () => void removeLocationPin(pinId), [pinId])
}
